<template>
  <li :class="{ group: isFolder || (model.users && model.users.length) }">
    <span class="line"></span>
    <span class="item" v-if="model.hash">
      <span
          @click="toggle"
          class="cursor-pointer">
        <mini-icon-loader v-if="loading"/>
        <i class="ki-outline ki-folder fs-6 cursor-help"
           v-else
           title="Филиал"
           :class="isFolder || (model.users && model.users.length)
           ? model.status === 2 ? 'text-gray-300' : 'text-primary'
           : model.status === 2 ? 'text-gray-300' : 'text-gray-800'"></i>
        {{ model.title }}
        <span v-if="isFolder || (model.users && model.users.length)" class="arrow m-1" :class="{ active: isOpen }">
          <span></span>
          <span></span>
        </span>
      </span>
    </span>
    <ul class="employees__list" v-show="isOpen" v-if="isFolder || (model.users && model.users.length)">
      <branch-users-item
          v-for="(model, index) in model.head"
          :key="index"
          :model="model"
          :head="true">
      </branch-users-item>
      <branch-item
          v-for="(model, index) in model.children"
          :key="index"
          :model="model">
      </branch-item>
      <branch-users-item
          v-for="(user, index) in model.users"
          :key="index"
          :model="user">
      </branch-users-item>
    </ul>
  </li>
</template>

<script>
import BranchUsersItem  from '@/components/Branch/BranchUsersItem'
import MiniIconLoader   from '@/components/MiniIconLoader'
import axios            from "axios";

export default {
  name: 'BranchItem',
  components: { BranchUsersItem, MiniIconLoader },
  props: {
    model:  Object,
    open:   {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen:   false,
      loading:  false
    }
  },
  mounted() {
    this.isOpen = this.open
  },
  computed: {
    isFolder() {
      return this.model.children && (this.model.children && this.model.children.length)
    }
  },
  methods: {
    toggle() {
      if (!this.isOpen) {
        this.loading = true
        const header = {hash: this.model.hash}
        axios.post('/api/branches/branch', header)
            .then(res => { this.model.children = res.data })
            .catch(err => { console.log(err) })
            .finally(() => {
              this.loading  = false
              this.isOpen   = true
            })
      } else this.isOpen = false
    }
  }
}
</script>

<style scoped>
.item > .employee__btn-group {
  top: 2px;
}
.employee__tree-add i {
  color: #2196F3;
  opacity: .6;
}
.employee__tree-add_user i {
  border-right: 1px solid #cccccc;
  padding-right: 5px;
  color: #2196F3;
  opacity: .6;
}
.employee__tree-edit i {
  color: #FF9800;
  opacity: .6;
}
.employee__tree-add_user:hover i,
.employee__tree-add:hover i {
  opacity: 1;
}
.employee__tree-edit:hover i {
  opacity: 1;
}
</style>